import React from 'react'
import PropTypes from 'prop-types'
import formatMessage from 'format-message'

import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap'

class ReaderToolbarSearch extends React.Component {
  static propTypes = {
    coursenum: PropTypes.string.isRequired,
  }

  state = {
    searchInput: '',
    searchInputValid: true,
  }

  handleSearchInputChange = input => {
    this.setState({ searchInput: input })
  }

  handleSearchSubmission = e => {
    let searchInput = this.state.searchInput
    let searchInputValid = this.validateSearchInput(searchInput)
    if (searchInputValid) {
      $('#searchForm').submit()
    } else {
      e.preventDefault()
    }
  }

  validateSearchInput = input => {
    const MIN_SEARCH_LENGTH = 3
    let searchInputValid = input.length >= MIN_SEARCH_LENGTH
    this.setState({ searchInputValid: searchInputValid }, () => {
      searchInputValid = this.state.searchInputValid
    })
    return searchInputValid
  }

  render() {
    return (
      <div className="booktools_item">
        <div className="formErrors">
          {this.state.searchInputValid ? (
            <div />
          ) : (
            <p>
              {' '}
              {formatMessage(
                'Please enter at least { numberLetters, number } letters.',
                { numberLetters: 3 }
              )}
            </p>
          )}
        </div>
        <div className="accessibility_search accessibility_item">
          <form
            id="searchForm"
            method="GET"
            action={'/reader/search/' + this.props.coursenum + '/'}
            onSubmit={this.handleSearchSubmission}
            aria-label="Search entire text"
          >
            <FormGroup controlId="searchID">
              <ControlLabel style={{ marginBottom: '0px' }}>
                {formatMessage('Search')}
              </ControlLabel>
              <FormControl
                type="text"
                id="searchID"
                name="searchterms"
                onChange={e => this.handleSearchInputChange(e.target.value)}
                value={this.state.searchInput}
              />
            </FormGroup>
          </form>
        </div>
      </div>
    )
  }
}

export default ReaderToolbarSearch
